
import {
  QUOTATIONS_PAGINATOR_SET_CONFIGURATION_SLOPES_EMIT_QUOTATIONS,

  QUOTATIONS_PAGINATOR_GET_SLOPES_EMIT_QUOTATIONS_REQUEST,
  QUOTATIONS_PAGINATOR_GET_SLOPES_EMIT_QUOTATIONS_SUCCESS,
  QUOTATIONS_PAGINATOR_GET_SLOPES_EMIT_QUOTATIONS_ERROR,
} from 'Redux/types/tableQuotationsTypes';
import paginate from 'Redux/reducers/paginationReducer';


const quotationsSlopesToEmit = paginate({
  setPaginationConfigType: QUOTATIONS_PAGINATOR_SET_CONFIGURATION_SLOPES_EMIT_QUOTATIONS,
  types: [
    QUOTATIONS_PAGINATOR_GET_SLOPES_EMIT_QUOTATIONS_REQUEST,
    QUOTATIONS_PAGINATOR_GET_SLOPES_EMIT_QUOTATIONS_SUCCESS,
    QUOTATIONS_PAGINATOR_GET_SLOPES_EMIT_QUOTATIONS_ERROR,
  ],
});

export default quotationsSlopesToEmit;
